<div class="c-card">
	<div class="c-content u-no-p@up-to-md">
		<table-invoices [(invoices)]="vm.invoices" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></table-invoices>
	</div>
	<div *ngIf="vm.invoices && vm.invoices?.length > vm.pageSize">
		<div class="o-grid u-ost-md u-osb-md">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
				<list-pager [totalItems]="vm.invoices?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
			</div>
		</div>
	</div>
</div>
